import React, { useState, useRef, useEffect } from "react";
import {
  MDBCol,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBBtn,
  MDBIcon,
  MDBCardFooter,
  MDBBox,
} from "mdbreact";

import { useHistory, useLocation } from "react-router-dom";
import { url } from "api";
import formatTime from "helpers/formatTime";

import "../ProjectItemAdmin/ProjectItem.scss";
import "./ProjectCardActions.scss";
import moment from "moment";
import { eventTrack } from "helpers/ga4Helper";

import { useHttp } from "hooks/useHttp";
import { editProjectPut } from "api/projects/updateProject";
import addNotification from "helpers/notify";
import { adminEditProject } from "actions/admin";
import { useSelector, useDispatch } from "react-redux";
import Loading from "../ui-components/loading";

import { ALL_PERMISSIONS } from "constants/permissionsConstants";
import { createFeatureRequest } from "api/featureRequests/createFeatureRequest";
import { setFeatureRequest, setProjects } from "actions/user";
import { Modal } from "antd";
import ProjectModelSourcesModal from "components/ProjectModelSources/ProjectModelSourcesModal";
import AccCardStatus from "components/Acc/AccCardStatus";
import ProjectExportProgress from "components/Integrations/ProjectExportProgress";
import IntegrationCardButtons from "components/Integrations/IntegrationCardButtons";
import { setProjectArchived } from "api/projects/archiveProject";
import { RequestCard } from "pages/configuration/requestCard";
import { ClockCircleOutlined, InfoCircleOutlined } from "@ant-design/icons";
import DefaultImage from "assets/images/Default_Project_Image.png";
import { extractImageFromZip } from "helpers/extractImageFromZip";
import { isModelUploading, isModelPartial, modelCoverageLabel, modelFileCount } from "helpers/modelVisibility";
import { uploadFileToServer } from "components/uploadFile/uploadFile";

import FULL_BATTERY_IMG from "assets/images/full.jpg";
import THREE_QUARTER_BATTERY_IMG from "assets/images/three-quarter.jpg";
import HALF_BATTERY_IMG from "assets/images/half.jpg";
import ONE_THIRD_BATTERY_IMG from "assets/images/one-third.jpg";
import EMPTY_BATTERY_IMG from "assets/images/empty.jpg";

let numeral = require("numeral");
const ProjectItemPersonalArea = (props) => {
  const {
    img, 
    title,
    favourite,
    description,
    date,
    _id,
    timelines,
    user,
    zipInfo,
    isParent,
    parentProjectID,
    projectNumber,
    milestone,
  } = props.projectItem;

  // An export still in flight advertises a well-formed zipInfo long
  // before the model it describes is servable. Fail open: only an
  // explicit 'uploading' hides anything - see helpers/modelVisibility.
  const modelUploading = isModelUploading(props.projectItem);
  // Serving a model that is still filling in. It shows — but never
  // without saying so; see helpers/modelVisibility.
  const modelPartial = isModelPartial(props.projectItem);
  const modelCoverage = modelCoverageLabel(props.projectItem);

  const { isAdmin } = props;

  const { idUser } = props;
  const projectItemState = useRef({ img, title, description, _id });

  const dispatch = useDispatch();
  const history = useHistory();
  const imageRef = useRef();
  const location = useLocation();
  const userInfoRedux = useSelector((s) => s.user.userInfo);
  const usersPermissionRedux = useSelector((s) => s.user.userPermission);
  const companyPermissionRedux = useSelector((s) => s.user.companyPermission);
  const allPermissionRedux = useSelector((s) => s.user.allPermission);
  const [modelSourcesOpen, setModelSourcesOpen] = useState(false);
  const [archiving, setArchiving] = useState(false);
  // Who may change which files the model loads: the owner, a company
  // admin, or a member holding projectEdit (mirrors the PUT route).
  const canEditModelSources =
    idUser === user ||
    !!userInfoRedux?.admin ||
    !!userInfoRedux?.companyAdmin ||
    !!(allPermissionRedux || []).includes(ALL_PERMISSIONS.PROJECT_EDIT);
  const FinalPermissions = allPermissionRedux
    ?.filter((element) => companyPermissionRedux?.includes(element))
    ?.filter((i) => usersPermissionRedux?.includes(i));
  // Same gate as the drawer's Dashboard & Schedule entry (newDrawer.jsx).
  const canOpenCoordination =
    !!userInfoRedux?.admin ||
    !!userInfoRedux?.companyAdmin ||
    !!FinalPermissions?.includes(ALL_PERMISSIONS.GANTT_VIEW) ||
    !!FinalPermissions?.includes(ALL_PERMISSIONS.ISSUE_VIEW);
  const featureRequestRedux = useSelector((s) => s.user.featureRequest);
  const projectsRedux = useSelector((s) => s.user.projects);
  const usersRedux = useSelector((s) => s.user.users);
  const milestonesRedux = useSelector((s) => s.user.milestones);

  const [requestType, setRequestType] = useState("");
  const [requestModal, setRequestModal] = useState(false);
  const [requestLoading, setRequestLoading] = useState(false);
  const [projectPicture, setProjectPicture] = useState(null);

  const changeProject = (prop, payload) => {
    projectItemState.current = { ...projectItemState.current, [prop]: payload };
  };
  const editProjectForm = new FormData();

  const editProjectField = (field) => {
    editProjectForm.append(field, projectItemState.current[field]);
  };

  const { loading, request: editProjectAPI } = useHttp({
    requestCallback: editProjectPut,
    onLoad: (res) => {
      const cloneProjectArr = [...projectsRedux];
      const i = cloneProjectArr.findIndex((x) => x._id === res._id);
      cloneProjectArr[i] = res;

      addNotification("Project updated successfully", "success");
      dispatch(setProjects(cloneProjectArr));
      if (res.img !== props.img) {
        imageRef.current.src = `${res.img}`;
      }
      dispatch(adminEditProject(res));
    },
    onError: (res) => {
      // addNotification(res.message, "danger");
    },
  });

  const editProject = () => {
    editProjectField("_id", _id);
    editProjectField("title", title);
    editProjectField("description", description);
    editProjectField("img", img);

    return editProjectAPI({
      id: projectItemState.current._id,
      body: editProjectForm,
    });
  };

  useEffect(() => {
    let isMounted = true;

    (async () => {
      if (img?.split(".").pop() === "gz") {
        const extractedImg = await extractImageFromZip(img);
        if (isMounted) {
          setProjectPicture(extractedImg);
        }
      } else {
        if (isMounted) {
          setProjectPicture(DefaultImage);
        }
      }
    })();

    return () => {
      isMounted = false;
    };
  }, [img, projectsRedux]);

  const toggleFavorite = (value) => {
    editProjectField("_id", _id);
    return editProjectAPI({
      _id: projectItemState.current._id,
      favourite: !value,
    });
  };

  const isIfcProject = props.projectItem.isIfcProject;

  const hiddenFileInput = useRef(null);
  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  const requestAccess = async () => {
    try {
      setRequestLoading(true);
      const res = await createFeatureRequest(userInfoRedux?.id, {
        companyId: userInfoRedux.company,
        permission: requestType,
        userId: userInfoRedux.id,
      });
      if (res) {
        setRequestLoading(false);
        dispatch(
          setFeatureRequest(res?.map((feature) => feature?.requestedFeature))
        );
      }
    } catch (e) {
      setRequestLoading(false);
    }
  };

  const handleImageChange = async (file) => {
    const fileUrl = await uploadFileToServer(file);
    editProjectField("_id", _id);
    return editProjectAPI({
      _id: projectItemState.current._id,
      img: fileUrl,
    });
  };

  return (
    <MDBCol className={props.className}>
      <MDBCard className="h-100">
        <div
          className={`project-item-img ${
            isIfcProject ? "ifcIcon" : "revitIcon"
          }`}
        >
          <img
            src={projectPicture}
            alt={`Project ${title}`}
            ref={imageRef}
            onError={(e) => (e.target.src = DefaultImage)}
          />

          <div className="project-card-fav cursor-pointer">
            {loading ? (
              <i className="fa fa-spinner small-spinner" />
            ) : (
              <div onClick={() => { toggleFavorite(favourite)
                {
                  eventTrack(
                    "Toggle-Fav-Action",
                    "Toggle-Fav",
                    userInfoRedux?.name,
                    "+1",
                    false,
                    "+1"
                  );
                }
              }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="19"
                  height="19"
                  viewBox="0 0 19 19"
                  fill="none"
                >
                  <g clipPath="url(#clip0_426_6573)">
                    <rect
                      width="18"
                      height="18"
                      transform="translate(0.455078 0.45459)"
                      fill="white"
                    />
                    <path
                      d="M9.45602 14.1496L4.16593 17.1107L5.34743 11.1645L0.896484 7.04844L6.91676 6.33463L9.45602 0.82959L11.9952 6.33463L18.0155 7.04844L13.5646 11.1645L14.7461 17.1107L9.45602 14.1496Z"
                      fill={favourite ? "#FFBF1B" : "#ddd"}
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_426_6573">
                      <rect
                        width="18"
                        height="18"
                        fill="white"
                        transform="translate(0.455078 0.45459)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            )}
          </div>
          <span className="project-item-date">{formatTime(date)}</span>
        </div>
        <MDBCardBody className="p-3 position-relative">
          {/* {loading ? <Loading color="dark" text="Editing..." /> : null} */}
          <MDBBox className="upload-project-card-img">
            <input
              style={{ display: "none" }}
              type="file"
              name="file_image"
              className="file-input"
              id="input_image"
              required
              accept={".jpeg,.png,.jpg,.png"}
              disabled={loading}
              ref={hiddenFileInput}
              onChange={(e) => {
                handleImageChange(e.target.files[0]);
              }}
            />
            {isAdmin ? (
              <MDBBtn
                size="sm"
                color=""
                onClick={() => { handleClick()
                  {
                    eventTrack(
                      "Upload-Project-Image-Action",
                      "Upload-Project-Image",
                      userInfoRedux?.name,
                      "+1",
                      false,
                      "+1"
                    );
                  }
                }}
                disabled={loading}
              >
                {loading ? (
                  <i className="fa fa-spinner small-spinner" />
                ) : (
                  <MDBIcon icon="camera" className="font-size-1" />
                )}
              </MDBBtn>
            ) : null}
          </MDBBox>

          <MDBBox className="font-size-1 text-bid capitalize d-flex align-items-center battery-container battery-card-container">
            {/* Project completion:{" "} */}
            {Number(
              milestonesRedux?.find((item) => item?._id === milestone)?.value
            ) == 0 ? (
              <img
                src={EMPTY_BATTERY_IMG}
                alt="FULL_BATTERY_IMG"
                title={`${
                  milestonesRedux?.find((item) => item?._id === milestone)
                    ?.value
                }${"%"}`}
              />
            ) : Number(
                milestonesRedux?.find((item) => item?._id === milestone)?.value
              ) <= 25 &&
              Number(
                milestonesRedux?.find((item) => item?._id === milestone)?.value
              ) > 0 ? (
              <img
                src={ONE_THIRD_BATTERY_IMG}
                alt="FULL_BATTERY_IMG"
                title={`${
                  milestonesRedux?.find((item) => item?._id === milestone)
                    ?.value
                }${"%"}`}
              />
            ) : Number(
                milestonesRedux?.find((item) => item?._id === milestone)?.value
              ) <= 50 &&
              Number(
                milestonesRedux?.find((item) => item?._id === milestone)?.value
              ) >= 26 ? (
              <img
                src={HALF_BATTERY_IMG}
                alt="FULL_BATTERY_IMG"
                title={`${
                  milestonesRedux?.find((item) => item?._id === milestone)
                    ?.value
                }${"%"}`}
              />
            ) : Number(
                milestonesRedux?.find((item) => item?._id === milestone)?.value
              ) <= 75 &&
              Number(
                milestonesRedux?.find((item) => item?._id === milestone)?.value
              ) >= 51 ? (
              <img
                src={THREE_QUARTER_BATTERY_IMG}
                alt="FULL_BATTERY_IMG"
                title={`${
                  milestonesRedux?.find((item) => item?._id === milestone)
                    ?.value
                }${"%"}`}
              />
            ) : Number(
                milestonesRedux?.find((item) => item?._id === milestone)?.value
              ) <= 100 &&
              Number(
                milestonesRedux?.find((item) => item?._id === milestone)?.value
              ) >= 76 ? (
              <img
                src={FULL_BATTERY_IMG}
                alt="FULL_BATTERY_IMG"
                title={`${
                  milestonesRedux?.find((item) => item?._id === milestone)
                    ?.value
                }${"%"}`}
              />
            ) : null}
          </MDBBox>

          <MDBCardTitle className="mb-1 font-size-2">{title}</MDBCardTitle>
          {/* Linked to a Revit file in ACC: its path, and while the server
              reads and publishes it a spinner with when it will be ready. */}
          <AccCardStatus projectId={_id} />
          {/* Exporting to 3D right now: how far, and a way straight to its live log.
              Nothing is drawn when nothing is running (owner 2026-10-25). */}
          <ProjectExportProgress projectId={_id} info={props.exportInfo} />
          {timelines && timelines[0] && timelines[0].estimation ? (
            <MDBBox className="card-price font-size-2 mb-1 text-bid">
              {numeral(timelines[timelines.length - 1].estimation).format(
                `${timelines[timelines.length - 1]?.currencysymb} 0,0.00`
              )}
            </MDBBox>
          ) : null}

          <MDBCardText className="capitalize text-bid">
            {description}
          </MDBCardText>
          <MDBBox className="font-size-1 text-bid capitalize">
            Project Number: {projectNumber ? projectNumber : "N/A"}
          </MDBBox>
          {zipInfo && !modelUploading ? (
            <MDBBox className="">
              <hr />
              <div className="modelDiv">
                <MDBCardTitle className="mb-1 font-size-2">
                  Model
                  {modelPartial && (
                    <span
                      className="ml-2 font-size-1"
                      style={{
                        background: "#FFF3CD", color: "#7A5B00",
                        border: "1px solid #F0D48A", borderRadius: 3,
                        padding: "1px 6px", fontWeight: 600, whiteSpace: "nowrap",
                      }}
                      title="This model is still being uploaded. Some documents are not in it yet."
                    >
                      Partial{modelCoverage ? ` — ${modelCoverage}` : ""}
                    </span>
                  )}
                </MDBCardTitle>
                {props.projectItem.isIfcProject ? (
                  <div>
                    <button
                      className="bg-white text-bid border-bid shadow-none text-style-inherit"
                      onClick={props.openUpdateModal}
                    >
                      <small>update </small>
                      <MDBIcon fas icon="upload" />
                    </button>
                  </div>
                ) : null}
              </div>
              {zipInfo ? (
                <MDBBox className="font-size-1 text-bid">
                  Exported by:{" "}
                  {zipInfo?.exportedBy?.name
                    ? `${zipInfo?.exportedBy.name} ${zipInfo?.exportedBy.lastName}`
                    : zipInfo?.exportedBy ?? "N/A"}
                </MDBBox>
              ) : null}

              {zipInfo ? (
                <MDBBox className="font-size-1 text-bid">
                  Date: {moment(zipInfo.date).format("MMM Do YY , h:mm:ss a")}{" "}
                </MDBBox>
              ) : null}

              {/*<MDBBox className="font-weight-light font-size-1 mb-1">Exported by   { zipInfo.exportedBy} </MDBBox>*/}
            </MDBBox>
          ) : null}
        </MDBCardBody>
        {/* Two rows: the pages a project opens onto as labelled buttons
            (an even grid, so they line up card to card), then the
            project's tools as a row of same-size icons with delete kept
            apart at the end. */}
        <MDBCardFooter className="project-card-footer">
          <div className="pc-actions">
            {/* The View Model button. A separate predicate from the Model
                block above (paths.length, not truthy zipInfo), so it needs
                its own gate - gating only the block leaves a live button
                into an empty viewer. */}
            {modelFileCount(zipInfo) > 0 && !modelUploading && (
              <button
                className="pc-action primary"
                onClick={() => {
                  history.push(`./personal-area/projects/model-view/${_id}`);
                  eventTrack("View-Model-Action", "View-Model", title, _id, false, title);
                }}
              >
                <MDBIcon icon="cube" />
                <span>Model</span>
              </button>
            )}

            {/* Straight to this project's coordination dashboard - the
                same gate as the Dashboard & Schedule menu entry. */}
            {canOpenCoordination && (
              <button
                className="pc-action primary"
                onClick={() => {
                  history.push(`/coordination/${_id}`);
                  eventTrack("Open-Coordination-Action", "Open-Coordination", title, _id, false, title);
                }}
              >
                <MDBIcon icon="project-diagram" />
                <span>Coordination</span>
              </button>
            )}

            {isParent && (
              <button
                className="pc-action"
                onClick={() => {
                  history.push(`./personal-area/projects/${_id}/timelines`);
                  eventTrack("View-SubProjects-Action", "View-History", title, _id, false, title);
                }}
              >
                <MDBIcon icon="folder-open" />
                <span>Projects</span>
              </button>
            )}

            {FinalPermissions?.includes(ALL_PERMISSIONS.ESTIMATION_VIEW) ? (
              !isParent && (
                <button
                  className="pc-action"
                  onClick={() => {
                    if (!isParent && parentProjectID != "") {
                      history.push(`../${_id}`);
                    } else {
                      history.push(`./personal-area/projects/${_id}/timelines`);
                    }
                    eventTrack("View-History-Action", "View-History", title, _id, false, title);
                  }}
                >
                  <MDBIcon icon="clock" />
                  <span>History ({timelines?.length || 0})</span>
                </button>
              )
            ) : (
              <button
                className="pc-action"
                onClick={() => {
                  setRequestType(ALL_PERMISSIONS.ESTIMATION_VIEW);
                  setRequestModal(true);
                }}
              >
                <MDBIcon icon="clock" />
                <span>History</span>
              </button>
            )}

            <button
              className="pc-action"
              onClick={() => {
                if (FinalPermissions?.includes(ALL_PERMISSIONS.ASSIGN_PROJECT_ADD)) {
                  props.openMembersModal();
                } else {
                  setRequestType(ALL_PERMISSIONS.ASSIGN_PROJECT_ADD);
                  setRequestModal(true);
                }
                eventTrack("Project-Members-Action", "Project-Members", userInfoRedux?.name, "+1", false, "+1");
              }}
            >
              <MDBIcon icon="users" />
              <span>Members</span>
            </button>

            {idUser === user || { isAdmin } ? (
              <button
                className="pc-action"
                onClick={() => {
                  if (FinalPermissions?.includes(ALL_PERMISSIONS.SHARE_PROJECT_ADD)) {
                    props.openShareModal();
                  } else {
                    setRequestType(ALL_PERMISSIONS.SHARE_PROJECT_ADD);
                    setRequestModal(true);
                  }
                  eventTrack("Project-Access-Action", "Project-Access", userInfoRedux?.name, "+1", false, "+1");
                }}
              >
                <MDBIcon icon="share-alt" />
                <span>Access</span>
              </button>
            ) : null}
          </div>

          <div className="pc-tools">
            <button
              title="Export history"
              className="pc-tool"
              onClick={() => history.push(`/exports/history/${props.projectItem._id}`)}
            >
              <MDBIcon icon="history" />
            </button>

            {/* Model files: which source documents (host + links) the
                streamed model loads, and where each one sits (move, turn,
                scale). Saved on the project, applied in every viewer. */}
            <button
              title="Model files (choose which linked files load, and place each one)"
              className="pc-tool"
              onClick={() => setModelSourcesOpen(true)}
            >
              <MDBIcon icon="cog" />
            </button>
            <ProjectModelSourcesModal
              projectId={props.projectItem._id}
              projectTitle={title}
              open={modelSourcesOpen}
              onClose={() => setModelSourcesOpen(false)}
              canEdit={canEditModelSources}
            />

            {/* ACC and Procore: each logo in colour when the user is connected,
                checked when this project is linked, with its settings (delivery
                folders) beside it. Linking ACC queues the server-side export. */}
            <IntegrationCardButtons
              projectId={props.projectItem._id}
              projectTitle={title}
              canEdit={canEditModelSources}
            />

            {FinalPermissions?.includes(ALL_PERMISSIONS.ANALYTICS_VIEW) && (
              <button
                title="Project analytics"
                className="pc-tool"
                onClick={() => history.push(`/analytics/project/${props.projectItem._id}`)}
              >
                <MDBIcon icon="chart-line" />
              </button>
            )}

            {/* Archive: out of the main list and onto the Archived page,
                for every member; nothing else changes. On the Archived
                page the same button restores it. Same gate as editing. */}
            {canEditModelSources && (
              <button
                title={props.archived ? "Restore to My Projects" : "Archive (move to the Archived page)"}
                className="pc-tool"
                disabled={archiving}
                onClick={() => {
                  const toArchived = !props.archived;
                  Modal.confirm({
                    title: toArchived ? `Archive "${title}"?` : `Restore "${title}"?`,
                    content: toArchived
                      ? "The project leaves My Projects for the Archived page, for every member. Its model, issues and schedule stay as they are, and it can be restored at any time."
                      : "The project goes back to My Projects for every member.",
                    okText: toArchived ? "Archive" : "Restore",
                    onOk: async () => {
                      setArchiving(true);
                      try {
                        await setProjectArchived(_id, toArchived);
                        addNotification(toArchived ? "Project archived" : "Project restored", "success");
                        if (props.onArchived) props.onArchived(props.projectItem, toArchived);
                        else dispatch(setProjects((projectsRedux || []).filter((p) => p._id !== _id)));
                      } catch (e) {
                        addNotification(e?.err || e?.message || "Could not change the project's archive state", "danger");
                      } finally {
                        setArchiving(false);
                      }
                    },
                  });
                }}
              >
                <MDBIcon icon={props.archived ? "box-open" : "archive"} />
              </button>
            )}

            {idUser === user || { isAdmin } ? (
              <button
                title="Delete project"
                className="pc-tool danger"
                onClick={props.openDeleteModal}
              >
                <MDBIcon icon="trash-alt" />
              </button>
            ) : null}
          </div>
        </MDBCardFooter>
      </MDBCard>

      <Modal
        title={
          userInfoRedux?.companyAdmin ? "Acquire License" : "Request Access"
        }
        open={requestModal}
        footer={null}
        onCancel={() => setRequestModal(false)}
      >
        <RequestCard
          status={featureRequestRedux?.includes(requestType)}
          loading={requestLoading}
          icon={
            featureRequestRedux?.includes(requestType) ? (
              <ClockCircleOutlined style={{ color: "black" }} />
            ) : (
              <InfoCircleOutlined style={{ color: "black" }} />
            )
          }
          title={
            featureRequestRedux?.includes(requestType)
              ? `Request Already Sent`
              : `Oops, looks like you need to ${
                  userInfoRedux?.companyAdmin
                    ? `Acquire License`
                    : `Request Access`
                }`
          }
          description={
            featureRequestRedux?.includes(requestType)
              ? `Please reach out to your project Admin`
              : `Elevate your experience with exclusive futures, early releases, and premium features.`
          }
          buttonText={
            userInfoRedux?.companyAdmin ? "Acquire License" : "Request Access"
          }
          buttonHandler={() => requestAccess()}
        />
      </Modal>
    </MDBCol>
  );
};

export default ProjectItemPersonalArea;
